<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { clone } from '@/util/utils';
import { supplier as supplierCy } from '@orderez/qa-utils/dist/orderEz/supplier';
import { wizardListenerMixin } from '@/mixins/wizard';
import VSelectSearch from '@/components/v3/patterns/VSelectSearch';
/**
 * Warehouse
 * @version 1.0.0
 * @since 3.18.0
 */

export default {
  mixins: [wizardListenerMixin],
  name: 'Warehouse',
  components: { VSelectSearch },
  data() {
    return {
      supplierCy,
      warehouses: [],
      warehouse: null,
    };
  },
  computed: {
    ...mapState('entities/products', ['stocktake']),
  },
  methods: {
    ...mapMutations('entities/products', ['UPDATE_STOCKTAKE_DRAFT']),
    ...mapActions('entities/distributors', ['distributorFetchWarehouses']),
    onNextStep() {
      this.UPDATE_STOCKTAKE_DRAFT({ warehouse: clone(this.warehouse), selectedProducts: [] });
      this.$emit('stepCompleted');
    },
  },
  watch: {
    warehouse: {
      immediate: true,
      handler(val) {
        if (!val || !Object.keys(val).length) this.disableNextStep();
        else this.enableNextStep();
      },
    },
  },
  async created() {
    if (this.stocktake.warehouse) {
      this.warehouse = clone(this.stocktake.warehouse);
    }

    const { data } = await this.distributorFetchWarehouses({ withLocations: true });
    this.warehouses = clone(data.data);
  },
};
</script>

<template>
  <div>
    <v-select-search
      name="warehouse"
      label="Warehouse Name"
      placeholder="Choose Warehouse"
      :hasClear="false"
      :data="warehouses"
      :selected="warehouse"
      @selected="warehouse = $event"
      isFullWidth
      :data-cy="supplierCy.PRODUCTS.STOCKTAKE.CONDUCT_STOCKTAKE.WAREHOUSE.BUTTON__WAREHOUSE"
    />
  </div>
</template>

<style lang="scss" scoped>
:deep() .select-search {
  &__trigger span {
    @include font-size(14px, 20px);

    &:not(.select-search__value) {
      color: $color-gray-6C;
    }
  }

  &__search-wrapper {
    display: none;
  }

  &__item {
    @include font-size(14px, 20px);
  }
}
</style>
